(() => {
  if (window.__hairahSignatureLoaded) return;
  window.__hairahSignatureLoaded = true;

  document.querySelectorAll('.menu-drawer__menu li, .menu-drawer__submenu li').forEach((item, index) => {
    item.style.setProperty('--hairah-menu-index', index);
  });

  const backToTop = document.querySelector('.hairah-back-to-top');
  if (backToTop) {
    const updateBackToTop = () => {
      const visible = window.scrollY > Math.max(620, window.innerHeight * 1.1);
      backToTop.hidden = false;
      backToTop.classList.toggle('is-visible', visible);
      backToTop.tabIndex = visible ? 0 : -1;
    };
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    window.addEventListener('scroll', updateBackToTop, { passive: true });
    updateBackToTop();
  }

  const personalizeErrors = (root = document) => {
    const english = document.documentElement.lang?.startsWith('en');
    root.querySelectorAll?.('.product-form-text__error, .cart-items__error, .errors li').forEach((message) => {
      const text = message.textContent.trim();
      if (!text || message.dataset.hairahMessage === 'true') return;
      if (/sold out|épuis|unavailable|indisponible/i.test(text)) {
        message.textContent = english ? 'This piece is no longer available in this selection.' : 'Cette pièce n’est plus disponible dans cette sélection.';
      }
      message.dataset.hairahMessage = 'true';
    });
  };
  personalizeErrors();
  if (document.body) {
    new MutationObserver((records) => records.forEach((record) => personalizeErrors(record.target)))
      .observe(document.body, { childList:true, subtree:true });
  }
})();
